export enum LocalStorageKeys {
  ACTIVE_LOCALE = 'ACTIVE_LOCALE',
  LOGGED_IN_USER = 'LOGGED_IN_USER',
}
